import React from 'react';

const GeneralTermsAndConditions = () => {
    return <>
        Všeobecné obchodné podmienky

        <p className={'my-3'}>
            Identifikačné údaje prevádzkovateľa zariadenia:
            Názov a adresa zariadenia: FORMA – Fitness & Gym, Rovenská 668/2, 905 01 Senica<br/><br/>
            Obchodné meno prevádzkovateľa: rovenski s. r. o.,<br/><br/>
            Sídlo prevádzkovateľa: Rovenská 668/2, 905 01 Senica<br/><br/>
            IČO prevádzkovateľa: 56703236<br/>
            DIČ prevádzkovateľa: 2122397013<br/><br/>
            Spoločnosť zapísaná v Obchodnom registri Okresného súdu Trnava, odd. Sro, vložka č. 58356/T<br/><br/>
            Zodpovedný vedúci:<br/>
            Michal Šúrek<br/>
            Tel.: 0917 461 735<br/>
            E-mail: info@formafitness.sk
        </p>
        <p className={'my-3'}>
            <h4>1. VŠEOBECNÉ USTANOVENIA</h4>
            <ul>
                <li>1.1. Tieto Všeobecné obchodné podmienky (ďalej len „VOP“) upravujú vzájomné práva a povinnosti medzi
                    Prevádzkovateľom a Klientom (v zmysle nižšie uvedených definícií) v súvislosti s objednávaním
                    Služieb prostredníctvom Rezervačného systému a ich poskytovaním zo strany Prevádzkovateľa.
                </li>
                <li>1.2. Pri akceptácii registrácie členstva vo FORMA – Fitness & Gym spôsobom uvedeným v týchto
                    Všeobecných obchodných podmienkach (ďalej len „VOP“) uzatvára Klient s Prevádzkovateľom zmluvu o
                    poskytovaní služieb samoobslužného fitness centra FORMA – Fitness & Gym (ďalej len „zmluva“). Tieto
                    VOP tvoria neoddeliteľnú súčasť zmluvy uzatvorenej medzi Klientom a Prevádzkovateľom.
                </li>
                <li>1.3. Potvrdením týchto VOP Klient vyhlasuje, že sa oboznámil s ich obsahom, ako aj s Prevádzkovým
                    poriadkom FORMA – Fitness & Gym a s podmienkami spracúvania osobných údajov. Tieto dokumenty sú
                    zverejnené na prihlasovacej stránke https://online.iclub.sk/#/ucet/prihlasenie (športovisko: Forma
                    Senica) a tiež v priestoroch centra.
                </li>
            </ul>
        </p>
        <p className={'my-3'}>
            <h4>2. DEFINÍCIE</h4>
            Pre účely týchto VOP majú nižšie uvedené pojmy nasledovný význam:
            <ul>
                <li>2.1. „Cenník“ – aktuálny prehľad cien za Služby poskytované Prevádzkovateľom, dostupný Klientom
                    prostredníctvom Rezervačného systému alebo k nahliadnutiu v Priestore.
                </li>
                <li>2.2. „Dostupnosť“ – možnosť Klienta rezervovať Služby na konkrétny dátum, čas a požadovanú dĺžku
                    trvania.
                </li>
                <li>2.3. „Klient“ – fyzická osoba, fyzická osoba – podnikateľ alebo právnická osoba využívajúca Služby
                    poskytované Prevádzkovateľom v Priestore.
                </li>
                <li>2.4. „Konto“ – používateľský účet Klienta v Rezervačnom systéme.</li>
                <li>2.5. „Kredit“ - predplatné na Služby poskytované Prevádzkovateľom, ktoré si Klient, registrovaný v
                    Rezervačnom systéme, predpláca vopred prostredníctvom platobnej brány v rámci Rezervačného systému
                    alebo v hotovosti priamo v Priestore Prevádzkovateľa. Klient je oprávnený tento Kredit využívať na
                    rezerváciu Služieb Prevádzkovateľa.
                </li>
                <li>2.6. „Platobné údaje“ – údaje slúžiace na úhradu Kreditu za poskytnuté Služby.</li>
                <li>2.7. „Poplatok“ – odmena účtovaná Prevádzkovateľom za poskytnutie Služieb.</li>
                <li>2.8. „Prihlasovacie údaje“ – jedinečná kombinácia prihlasovacieho mena (e-mailová adresa) a hesla
                    zvoleného Klientom pri vytváraní jeho používateľského konta.
                </li>
                <li>2.9. „Prevádzkovateľ“ – obchodná spoločnosť rovenski s. r. o., so sídlom Rovenská 668/2, 905 01
                    Senica, IČO 56703236, zapísaná v Obchodnom registri Okresného súdu Trnava, odd. Sro, vložka č.
                    58356/T.
                </li>
                <li>2.10. „Priestor“ – prevádzkové priestory Prevádzkovateľa nachádzajúce sa na adrese Rovenská 668/2,
                    905 01 Senica, v ktorých sú poskytované Služby.
                </li>
                <li>2.11. „Prevádzkový poriadok“ – dokument obsahujúci podrobnosti o podmienkach poskytovania a
                    využívania Služieb, umiestnený na viditeľnom mieste v Priestore Prevádzkovateľa.
                </li>
                <li>2.12. „Reklamačný poriadok“ – pravidlá uplatňovania práv Klientov vyplývajúcich zo zodpovednosti
                    Prevádzkovateľa za vady Služieb a spôsob ich vybavovania.
                </li>
                <li>2.13. „Rezervačný systém“ – elektronický systém dostupný prostredníctvom aplikácie iClub, umožňujúci
                    Klientovi overiť Dostupnosť, zadať Objednávku, vykonať Rezerváciu a uhradiť Poplatok.
                </li>
                <li>2.14. „Rezervačné údaje“ – informácie vyžadované od Klienta pri zadávaní Objednávky cez Rezervačný
                    systém.
                </li>
                <li>2.15. „Služby“ – služby, ktoré poskytuje Prevádzkovateľ v Priestore v rámci predmetu svojej
                    podnikateľskej činnosti v oblasti športovej činnosti.
                </li>
                <li>2.16. „VOP“ – tieto všeobecné obchodné podmienky Prevádzkovateľa, zverejnené na prihlasovacej
                    stránke a dostupné aj v Priestore Prevádzkovateľa.
                </li>
                <li>2.17. „Vybavenie reklamácie“ sa rozumie ukončenie reklamačného procesu jedným z nasledovných
                    spôsobov:
                    <ul>
                        <li>(a) poskytnutím náhradnej Služby,</li>
                        <li>(b) vrátením zaplatenej ceny za poskytnutú Službu,</li>
                        <li>(c) poskytnutím primeranej zľavy z ceny za poskytnutú Službu, alebo</li>
                        <li>(d) riadne odôvodneným zamietnutím reklamácie.</li>
                    </ul>
                </li>
                <li>2.18. „Vyššia moc“ – nepredvídateľné okolnosti nezávislé od vôle Prevádzkovateľa, ktoré znemožňujú
                    alebo obmedzujú poskytovanie Služieb (napr. rozhodnutia štátnych orgánov, prírodné katastrofy,
                    vojny, štrajky, havárie).
                </li>
                <li>2.19. „Zákon o ochrane spotrebiteľa“ – zákon č. 108/2024 Z. z. o ochrane spotrebiteľa a o zmene a
                    doplnení niektorých zákonov.
                </li>
                <li>2.20. „Zmluva“ – zmluvný vzťah medzi Prevádzkovateľom a Klientom, ktorého predmetom je poskytnutie
                    Služieb a úhrada príslušného Poplatku.
                </li>
                <li>2.21. „Osobný tréning“ – Služba individuálneho alebo skupinového (kruhového) vedenia cvičenia
                    Klienta trénerom, poskytovaná externým trénerom v zmysle bodu 4.6.
                </li>
                <li>2.22. „Premium vstup“ – prenájom Priestoru na výhradné použitie Klientom (a osobami, ktoré s ním
                    do Priestoru vstúpili) počas rezervovaného času, bez súčasnej prítomnosti iných Klientov.
                </li>
                <li>2.23. „InBody meranie“ – meranie telesného zloženia Klienta prístrojom InBody 270s v zmysle bodu
                    4.8.
                </li>
            </ul>
        </p>
        <p className={'my-3'}>
            <h4>3. PREVÁDZKOVÝ REŽIM</h4>
            <ul>
                <li>3.1. Prevádzka funguje ako samoobslužné fitness centrum, bez stálej prítomnosti zástupcu
                    Prevádzkovateľa počas otváracích hodín.
                </li>
                <li>3.2. Otváracie hodiny centra sú podľa objednávok (vstup podľa vytvorenej rezervácie v aplikácii
                    iClub).
                </li>
                <li>3.3 Vstup do Priestorov centra je možný iba prostredníctvom aplikácie iClub.sk, a to najskôr 15
                    minút pred samotným začiatkom rezervovanej Služby.
                </li>
                <li>3.4. Rezervácia Služby je podmienená dostupnou kapacitou a dostatočným Kreditom Klienta na jeho
                    Konte.
                </li>
            </ul>
        </p>
        <p className={'my-3'}>
            <h4>4. POSKYTOVANÉ SLUŽBY</h4>
            <ul>
                <li>4.1. Základnou poskytovanou službou je 60-minútový vstup Klienta do Priestorov FORMA – Fitness &
                    Gym, za účelom individuálneho cvičenia a športovej aktivity (ďalej len „vstup“). Táto služba
                    oprávňuje Klienta využívať priestory určené na cvičenie, ako aj šatne a hygienické zariadenia, a to
                    v súlade s podmienkami bežného užívania a týmito VOP.
                </li>
                <li>4.2. Vstup do Priestorov nezahŕňa služby osobného trénera, pokiaľ nebola Klientom osobitne
                    rezervovaná a uhradená Služba Osobný tréning podľa bodu 4.6 a nasl. Používanie posilňovacích a
                    iných zariadení je súčasťou vstupu, pričom Klient je povinný dodržiavať pokyny na ich bezpečné a
                    správne používanie. Po ukončení cvičenia je Klient povinný všetky použité zariadenia vrátiť do
                    pôvodného stavu, vykonať ich dezinfekciu, a rovnako dezinfikovať a uložiť všetky použité pomôcky na
                    určené miesto.
                </li>
                <li>4.3. Prevádzkovateľ je oprávnený kedykoľvek ukončiť vstup a vyzvať Klienta na opustenie Priestoru v
                    prípade porušenia povinností vyplývajúcich z týchto VOP alebo nedodržania pokynov Prevádzkovateľa,
                    ktoré sú zamerané na ochranu zdravia, bezpečnosti Klientov alebo prevenciu škôd. V takomto prípade
                    je Klient povinný uhradiť cenu vstupu a nevzniká mu nárok na žiadnu formu náhrady alebo kompenzácie.
                </li>
                <li>4.4. Úhrada za vstup sa vykonáva automaticky odpočítaním z Kreditu Klienta v súlade s týmito VOP.
                </li>
                <li>4.5. Na vstup do Priestoru využíva Klient svoj QR kód, ktorý slúži na otvorenie zabezpečených
                    vstupných dverí. Klient si je vedomý, že vstup počas dočasného obmedzenia prevádzky (napr. z dôvodu
                    vládnych opatrení alebo zásahov orgánov verejnej správy) nie je povolený. V prípade, že Klient tento
                    zákaz poruší, nesie plnú zodpovednosť za akékoľvek škody spôsobené Prevádzkovateľovi.
                </li>
                <li>4.6. Osobný tréning (individuálny a skupinový)
                    <ul>
                        <li>4.6.1. Osobný tréning zahŕňa vedenie cvičenia Klienta trénerom počas rezervovaného času
                            podľa aktuálneho Cenníka. Rezervácia Osobného tréningu prebieha rovnako ako rezervácia
                            iných Služieb, prostredníctvom Rezervačného systému, a je podmienená dostupnosťou
                            zvoleného trénera.
                        </li>
                        <li>4.6.2. Osobný tréning poskytuje externý tréner, ktorý poskytuje svoje služby na základe
                            osobitného vzťahu s Prevádzkovateľom alebo priamo s Klientom. Prevádzkovateľ zabezpečuje
                            sprostredkovanie rezervácie a priestoru na výkon Osobného tréningu; za odbornú úroveň
                            vedenia tréningu zodpovedá tréner.
                        </li>
                        <li>4.6.3. Klient je povinný pred prvým Osobným tréningom informovať trénera o svojom
                            zdravotnom stave, prípadných obmedzeniach a kontraindikáciách relevantných pre fyzickú
                            záťaž.
                        </li>
                        <li>4.6.4. Na storno podmienky Osobného tréningu sa vzťahuje bod 9 týchto VOP, pokiaľ nie je
                            pri rezervácii trénera uvedené inak.
                        </li>
                    </ul>
                </li>
                <li>4.7. Premium vstup (prenájom Priestoru)
                    <ul>
                        <li>4.7.1. Premium vstup umožňuje Klientovi výhradné využitie fitness Priestoru na súkromný
                            tréning počas rezervovaného času, bez prítomnosti iných Klientov nesúvisiacich s jeho
                            rezerváciou.
                        </li>
                        <li>4.7.2. Klient je oprávnený do Priestoru v rámci Premium vstupu priviesť ďalšie osoby v
                            počte, ktorý nepresahuje maximálnu kapacitu Priestoru podľa Prevádzkového poriadku. Klient
                            zodpovedá za všetky osoby, ktoré s ním do Priestoru vstúpili, v rozsahu podľa bodu 8.10 a
                            10.1 týchto VOP.
                        </li>
                        <li>4.7.3. Na Premium vstup sa inak primerane vzťahujú ustanovenia bodov 4.1 až 4.5 a storno
                            podmienky podľa bodu 9.
                        </li>
                    </ul>
                </li>
                <li>4.8. InBody meranie telesného zloženia
                    <ul>
                        <li>4.8.1. InBody meranie je samostatná Služba spočívajúca v meraní telesného zloženia
                            Klienta prístrojom InBody 270s (bioelektrická impedančná analýza), poskytovaná buď ako
                            úvodné meranie s konzultáciou, alebo ako balík kontrolných meraní podľa aktuálneho
                            Cenníka.
                        </li>
                        <li>4.8.2. Podmienkou poskytnutia InBody merania je udelenie osobitného výslovného súhlasu so
                            spracúvaním osobných údajov o zdraví a podpísanie vyhlásenia o zdravotnom stave Klientom,
                            a to formou samostatného dokumentu poskytovaného Prevádzkovateľom pred prvým meraním. Bez
                            udelenia tohto súhlasu nie je možné InBody meranie vykonať.
                        </li>
                        <li>4.8.3. InBody meranie z bezpečnostných dôvodov nemôže byť vykonané u tehotných žien a u
                            osôb s kardiostimulátorom alebo iným implantovaným elektronickým zdravotníckym
                            prístrojom. Klient je povinný pred meraním pravdivo vyhlásiť, že sa naňho tieto
                            obmedzenia nevzťahujú.
                        </li>
                        <li>4.8.4. InBody meranie u osoby mladšej ako 18 rokov je možné vykonať len so súhlasom
                            zákonného zástupcu a spôsobom uvedeným v osobitnom dokumente podľa bodu 4.8.2.
                        </li>
                        <li>4.8.5. Výsledky InBody merania majú výhradne informatívny a orientačný charakter, nejde o
                            lekárske vyšetrenie ani diagnostiku a nenahrádzajú konzultáciu s lekárom. Prevádzkovateľ
                            nezodpovedá za zdravotné, výživové ani tréningové rozhodnutia Klienta urobené na základe
                            výsledkov merania.
                        </li>
                        <li>4.8.6. Na storno podmienky rezervácie InBody merania sa primerane vzťahuje bod 9 týchto
                            VOP.
                        </li>
                    </ul>
                </li>
            </ul>
        </p>
        <p className={'my-3'}>
            <h4>5. REGISTRÁCIA A PRIHLÁSENIE KLIENTA DO REZERVAČNÉHO SYSTÉMU</h4>
            <ul>
                <li>5.1. Prevádzkovateľ zabezpečuje prístup k Rezervačnému systému prostredníctvom aplikácie iClub.</li>
                <li>5.2. Pre riadne používanie Rezervačného systému a čerpanie Služieb je Klient povinný vykonať
                    registráciu v súlade s pokynmi, ktoré sú uvedené počas registračného procesu.
                </li>
                <li>5.3. V rámci registrácie Klienta do Rezervačného systému je potrebné poskytnúť tieto údaje:
                    <ul>
                        <li>(a) meno a priezvisko,</li>
                        <li>(b) telefónne číslo,</li>
                        <li>(c) e-mailová adresa (slúži ako prihlasovacie meno),</li>
                        <li>(d) heslo na prihlásenie do Konta.</li>
                    </ul>
                </li>
                <li>5.4. Dokončením registrácie Klient potvrdzuje, že sa oboznámil a súhlasí s aktuálnym znením VOP.
                </li>
                <li>5.5. Po úspešnom overení registrácie je Klientovi zriadené Konto. Následné prihlásenie do
                    Rezervačného systému sa realizuje prostredníctvom prihlasovacích údajov, ktoré Klient zadal pri
                    registrácii.
                </li>
                <li>5.6. Klient je povinný používať Rezervačný systém tak, aby nedošlo k neoprávnenému prístupu tretích
                    osôb k jeho Kontu. Zodpovedá za ochranu svojich prihlasovacích údajov vrátane hesla pred zneužitím
                    či únikom. V prípade, že dôjde k neoprávnenému prístupu k jeho Kontu alebo k zneužitiu
                    prihlasovacích údajov, je Klient povinný bezodkladne informovať Prevádzkovateľa. Klient zároveň
                    zodpovedá za všetky úkony vykonané prostredníctvom jeho Konta.
                </li>
                <li>5.7. Osoba mladšia ako 18 rokov sa môže zaregistrovať len prostredníctvom registračného
                    formulára vyplneného a potvrdeného jej zákonným zástupcom, ktorý zároveň zodpovedá za obsah
                    poskytnutých údajov a za dodržiavanie týchto VOP zo strany maloletého Klienta.
                </li>
            </ul>
        </p>
        <p className={'my-3'}>
            <h4>6. OBJEDNÁVKA A REZERVÁCIA SLUŽBY PROSTREDNÍCTVOM REZERVAČNÉHO SYSTÉMU</h4>
            <ul>
                <li>6.1 Klient je pri vytváraní Objednávky prostredníctvom Rezervačného systému povinný zadať požadované
                    údaje na rezerváciu, najmä dátum a čas, v ktorom má byť Služba poskytnutá (ďalej len „Rezervačné
                    údaje“).
                </li>
                <li>6.2 Rezerváciu Služby je možné uskutočniť výlučne prostredníctvom Rezervačného systému
                    Prevádzkovateľa. Klient si môže vybrať z dostupných časových slotov na základe aktuálnej kapacity a
                    obsadenosti Priestoru, pričom Rezervačný systém zohľadňuje aktuálnu dostupnosť.
                </li>
                <li>6.3 Po vyplnení všetkých požadovaných údajov podľa bodu 6.1 a ich potvrdení, Klient vykoná záväznú
                    rezerváciu. Rezervácia sa považuje za uzatvorenú okamihom doručenia potvrdzovacieho e-mailu zo
                    strany Prevádzkovateľa, v ktorom sú uvedené detaily rezervácie vrátane dátumu a času poskytnutia
                    Služby.
                </li>
                <li>6.4. Klient bude na blížiaci sa termín rezervovanej Služby automaticky upozornený pripomienkou
                    prostredníctvom e-mailu.
                </li>
                <li>6.5. Pripomienka bude zaslaná najneskôr 3 hodiny pred začiatkom rezervovaného termínu na e-mailovú
                    adresu uvedenú v registrácii Klienta.
                </li>
                <li>6.6. Klient berie na vedomie, že nezobrazovanie alebo neprijatie notifikácie z dôvodu technických
                    chýb na strane Klienta (napr. neaktuálny e-mail, spamový filter, vypnuté notifikácie) nemá vplyv na
                    jeho povinnosti vyplývajúce z platnej rezervácie a storno podmienok.
                </li>
                <li>6.7. Prevádzkovateľ si vyhradzuje právo meniť, upraviť alebo zrušiť dostupné termíny rezervácií z
                    dôvodu technickej údržby, technických porúch, zásahu vyššej moci alebo iných nepredvídaných
                    okolností, ktoré znemožňujú riadne poskytnutie Služby. O každej takejto zmene bude Klient
                    informovaný bez zbytočného odkladu prostredníctvom e-mailu alebo iného vhodného spôsobu komunikácie.
                </li>
            </ul>
        </p>
        <p className={'my-3'}>
            <h4>7. PLATBA ZA POSKYTOVANIE SLUŽIEB</h4>
            <ul>
                <li>7.1. Úhradu za objednané Služby realizuje Klient prostredníctvom predplateného dobíjateľného kreditu
                    („Kredit“), ktorý si dobíja vopred, buď prostredníctvom platobnej brány dostupnej v Rezervačnom
                    systéme, alebo v hotovosti priamo v Priestore Prevádzkovateľa.
                </li>
                <li>7.2. Po schválení registrácie je Klient oprávnený si kedykoľvek dobiť Kredit v minimálnej hodnote 10
                    EUR. Takto dobitý Kredit môže následne využiť na rezerváciu a úhradu dostupných Služieb
                    poskytovaných Prevádzkovateľom.
                </li>
                <li>7.3. Stav Kreditu je možné zistiť po prihlásení Klienta do aplikácie.</li>
            </ul>
        </p>
        <p className={'my-3'}>
            <h4>8. VSTUP DO PRIESTOROV A POSKYTNUTIE SLUŽIEB</h4>
            <ul>
                <li>8.1. QR kód, ktorý je Klientovi priradený po schválení registrácie, slúži ako jeho jedinečný
                    identifikátor pri vstupe do priestorov FORMA – Fitness & Gym, čím potvrdzuje jeho status
                    registrovaného používateľa.
                </li>
                <li>8.2. QR kód v aplikácii slúži na identifikáciu Klienta a spája sa vždy s konkrétnym registrovaným
                    Klientom. Jeho využitie inými osobami nie je dovolené a Klient nie je oprávnený umožniť použitie
                    svojho QR kódu inou osobou. Prevádzkovateľ je oprávnený odoprieť poskytnutie Služby osobe, ktorá
                    použila Klientsky QR kód, ktorý jej nepatrí.
                </li>
                <li>8.3. Klient je povinný použiť svoj QR kód v mobilnej aplikácii iClub na otvorenie vchodových dverí a
                    vstup Priestoru.
                </li>
                <li>8.4. Prístupový systém zaznamenáva čas vstupu. QR kód sa zaktivní najskôr 15 minút pred časom
                    Rezervácie Služby. Následne, po 45 minutách príde k jeho deaktivácii a Klient už nemá možnosť
                    vstúpiť do Priestoru.
                </li>
                <li>8.5. Po vstupe a počas pobytu v Priestore je Klient povinný dodržiavať všetky platné právne predpisy
                    týkajúce sa bezpečnosti a ochrany zdravia, protipožiarnej ochrany, ako aj tieto Všeobecné obchodné
                    podmienky a Prevádzkový poriadok Priestoru.
                </li>
                <li>8.6. Klient sa zaväzuje využívať Priestor výhradne na účely, ktoré sú v súlade s platnými právnymi
                    predpismi, technickými normami, bezpečnostnými pravidlami, týmito VOP a zásadami slušného správania.
                    Klient je povinný zabrániť poškodeniu, zničeniu alebo nadmernému znečisteniu Priestoru.
                </li>
                <li>8.7. Klient je povinný rešpektovať časové obmedzenia vyplývajúce z rezervácie a otváracie hodiny
                    Priestoru. Po uplynutí rezervovaného času je povinný ukončiť svoju činnosť a opustiť Priestor.
                </li>
                <li>8.8. V prípade, že Klient prekročí rezervovaný čas a neopustí Priestor načas, Prevádzkovateľ môže
                    jeho Konto v Rezervačnom systéme zablokovať a Klient nebude môcť uskutočniť ďalšie rezervácie.
                </li>
                <li>8.9. Klient sa zaväzuje rešpektovať nočný pokoj, ktorý platí v čase od 22:00 do 06:00 hod. V tomto
                    období je zakázané vykonávať hlučné aktivity, ktoré by mohli rušiť ostatných návštevníkov alebo
                    obyvateľov v okolí Priestoru.
                </li>
                <li>8.10. Klient je zodpovedný za to, aby všetky osoby, ktoré s ním vstúpili do Priestoru, dodržiavali
                    pravidlá nočného pokoja.
                </li>
                <li>8.11. V prípade opakovaného porušenia pravidiel nočného pokoja si Prevádzkovateľ vyhradzuje právo
                    jednostranne ukončiť rezerváciu bez nároku Klienta na akúkoľvek kompenzáciu či vrátenie Kreditu.
                </li>
            </ul>
        </p>
        <p className={'my-3'}>
            <h4>9. STORNO PODMIENKY, SKONČENIE PRÁVNEHO VZŤAHU A ZRUŠENIE REGISTRÁCIE</h4>
            <ul>
                <li>9.1. Klient je oprávnený zrušiť svoju rezerváciu bez akýchkoľvek poplatkov najneskôr 12 hodín pred
                    plánovaným začiatkom rezervovanej Služby. V takom prípade nebude z jeho Konta odpočítaný žiadny
                    Kredit.
                </li>
                <li>9.2. V prípade, ak Klient zruší rezerváciu v lehote kratšej ako 12 hodín pred jej začiatkom, alebo
                    sa na rezervovanú Službu bez predchádzajúceho zrušenia nedostaví, Kredit za danú Službu bude
                    považovaný za prepadnutý a nebude možné požadovať jeho vrátenie ani kompenzáciu.
                </li>
                <li>9.3. Prevádzkovateľ si vyhradzuje právo výnimočne odpustiť prepadnutie kreditu v prípade, ak Klient
                    preukáže, že mu v účasti na rezervovanej Službe zabránili mimoriadne a objektívne prekážky (napr.
                    zdravotné dôvody, živelná udalosť a pod.), pričom o tejto skutočnosti informoval Prevádzkovateľa
                    bezodkladne.
                </li>
                <li>9.4. V prípade zrušenia rezervácie zo strany Prevádzkovateľa (napr. z technických alebo
                    prevádzkových dôvodov), bude Kredit v plnej výške vrátený späť na Konto Klienta, alebo – ak Klient
                    požiada – nahradený iným vhodným termínom.
                </li>
                <li>9.5. Klient berie na vedomie, že v súlade s § 7 ods. 6 zákona o ochrane spotrebiteľa nemôže
                    odstúpiť od zmluvy o poskytnutí jednotlivej Služby (rezervácie konkrétneho vstupu, Osobného
                    tréningu, Premium vstupu alebo InBody merania), pretože ide o službu súvisiacu s činnosťou
                    voľného času, ktorú sa Prevádzkovateľ zaväzuje poskytnúť v dohodnutom termíne.
                </li>
                <li>9.5.1. Vo vzťahu k registrácii Konta a k dobitiu Kreditu, ktoré nie sú viazané na konkrétny
                    termín poskytnutia Služby, má Klient, ak je spotrebiteľom, právo odstúpiť od zmluvy bez uvedenia
                    dôvodu v lehote 14 dní odo dňa jej uzatvorenia, a to zaslaním jednoznačného vyhlásenia o
                    odstúpení na e-mail info@formafitness.sk alebo poštou na adresu sídla Prevádzkovateľa. V prípade
                    odstúpenia Prevádzkovateľ vráti Klientovi nevyčerpaný Kredit bez zbytočného odkladu, najneskôr do
                    14 dní odo dňa doručenia odstúpenia, rovnakým spôsobom, akým bola platba prijatá, pokiaľ sa
                    Klient a Prevádzkovateľ nedohodnú inak. Právo na odstúpenie podľa tohto bodu sa nevzťahuje na
                    Kredit, ktorý už bol ku dňu odstúpenia vyčerpaný na rezervované a poskytnuté Služby.
                </li>
                <li>9.6 Zrušenie registrácie a zrušenie Konta môže Klient uskutočniť na základe písomnej žiadosti
                    doručenej poštou na adresu Prevádzkovateľa alebo emailom na adresu info@formafitness.sk, prípadne
                    prostredníctvom výpovede podanej Klientom alebo Prevádzkovateľom v súlade s príslušnými
                    ustanoveniami Občianskeho zákonníka. Po doručení žiadosti je Prevádzkovateľ oprávnený kontaktovať
                    Klienta telefonicky za účelom overenia jeho totožnosti. Po úspešnom overení môže Prevádzkovateľ
                    žiadosť schváliť. Schválením žiadosti zo strany Prevádzkovateľa dochádza k zániku zmluvy medzi
                    Klientom a Prevádzkovateľom dohodou a zároveň k zrušeniu zákazníckeho konta Klienta. Do 15
                    pracovných dní od zrušenia Konta Prevádzkovateľ vráti Klientovi nevyčerpaný Kredit, znížený o
                    manipulačný poplatok vo výške 10 EUR, ktorý slúži na pokrytie administratívnych nákladov spojených
                    so zrušením Konta a prevodom finančných prostriedkov. Kredit bude vrátený bezhotovostne na bankový
                    účet vedený v Slovenskej republike, ktorý Klient uvedie v žiadosti o zrušenie registrácie. Vrátenie
                    Kreditu v hotovosti nie je možné. Právny vzťah medzi Klientom a Prevádzkovateľom sa skončí aj v
                    prípade, ak Klient počas 12 mesiacov od posledného uhradenia Kreditu neuhradí žiadne ďalšie
                    predplatné, nevyužije žiadne Služby a zároveň v tejto lehote nepožiada Prevádzkovateľa o predĺženie
                    platnosti zákazníckeho Konta.
                </li>
            </ul>
        </p>
        <p className={'my-3'}>
            <h4>10. ZODPOVEDNOSŤ ZA ŠKODU A BEZPEČNOSŤ KLIENTOV</h4>
            <ul>
                <li>10.1. Klient nesie plnú zodpovednosť za akúkoľvek škodu spôsobenú na majetku Prevádzkovateľa, a to
                    aj v prípade, ak bola spôsobená z nedbanlivosti. Klient rovnako zodpovedá za škodu, ktorú v
                    Priestore spôsobí sám alebo osoba, ktorá s ním do Priestoru vstúpila a za dodržiavanie povinností
                    ktorej Klient zodpovedá podľa bodu 8.10. Klient sa zaväzuje uhradiť vzniknutú škodu v plnom
                    rozsahu.
                </li>
                <li>10.2. Klient je povinný zaobchádzať so zariadením a vybavením Priestoru a s majetkom Prevádzkovateľa
                    (vrátane majetku, ktorý má Prevádzkovateľ v nájme, výpožičke alebo inom oprávnenom užívaní) s
                    maximálnou starostlivosťou, aby nedošlo k jeho poškodeniu alebo zničeniu. Prevádzkovateľ nezodpovedá
                    za škody na zdraví alebo majetku spôsobené Klientom v dôsledku porušenia Zmluvy a/alebo týchto VOP.
                </li>
                <li>10.3. Prevádzkovateľ nezodpovedá za spôsob využívania Služieb Klientom a nie je povinný poskytovať
                    mu individuálnu inštruktáž alebo poradenstvo ohľadom ich použitia.
                </li>
                <li>10.4. Prevádzkovateľ nezodpovedá za neposkytnutie alebo obmedzené poskytnutie Služieb v prípade
                    zásahu vyššej moci. Rovnako nenesie zodpovednosť za funkčnosť, správnosť, úplnosť alebo bezchybnosť
                    mobilnej aplikácie iClub.
                </li>
                <li>10.5. Klient je pri vstupe do Priestoru povinný dôkladne skontrolovať jeho stav a bezodkladne zistiť
                    prípadné poškodenia.
                </li>
                <li>10.6. V prípade, že Klient zistí poškodenie Priestoru alebo majetku Prevádzkovateľa, je povinný:
                    <ul>
                        <li>(a) vyhotoviť fotografickú dokumentáciu poškodenia,</li>
                        <li>(b) bezodkladne informovať Prevádzkovateľa e-mailom na adresu: info@formafitness.sk .</li>
                    </ul>
                </li>
                <li>10.7. Prevádzkovateľ sa zaväzuje reagovať na oznámenie Klienta v primeranej lehote a následne
                    posúdiť oznámené poškodenie.
                </li>
                <li>10.8. Na základe oznámenia Klienta prijme Prevádzkovateľ primerané opatrenia na odstránenie
                    poškodenia alebo zabezpečí nápravu vzniknutej situácie.
                </li>
                <li>10.9. Ak Klient neoznámil poškodenie v súlade s týmito podmienkami, môže byť zodpovedný za náklady
                    spojené s opravou alebo náhradou poškodeného majetku.
                </li>
                <li>10.10. Prevádzkovateľ nezodpovedá za škodu na veciach vnesených alebo odložených v prevádzke počas
                    využívania služieb.
                </li>
                <li>10.11. Klient používa všetky zariadenia a vybavenie prevádzky na vlastné riziko. Prevádzkovateľ
                    nezodpovedá za škody na zdraví, ktoré si návštevník spôsobí sám, najmä v dôsledku nedodržania
                    prevádzkového poriadku, pokynov zodpovedných osôb alebo nesprávneho používania zariadení.
                </li>
                <li>10.12. Prevádzkovateľ nezodpovedá za úrazy spôsobené inou osobou, alebo ktoré vznikli v dôsledku
                    porušenia povinností tretích osôb.
                </li>
                <li>10.13. V prípade zranenia alebo nehody je Klient povinný túto skutočnosť bezodkladne oznámiť
                    Prevádzkovateľovi (alebo ním poverenej osobe), aby bolo možné zabezpečiť riadne zdokumentovanie a
                    pomoc.
                </li>
            </ul>
        </p>
        <p className={'my-3'}>
            <h4>11. ZODPOVEDNOSŤ ZA VADY SLUŽBY, REKLAMÁCIE</h4>
            <ul>
                <li>11.1. Prevádzkovateľ zodpovedá za to, že poskytovaná Služba bude bez vád a bude zodpovedať
                    dohodnutým kvalitatívnym štandardom, a to v súlade s povahou Služby a uzatvorenou zmluvou.
                </li>
                <li>11.2. V prípade, že Klient zistí vadu na poskytovanej Službe alebo nesprávne vyúčtovanie, je
                    oprávnený uplatniť reklamáciu bez zbytočného odkladu po jej zistení, najneskôr však do 7 dní odo
                    dňa poskytnutia Služby, resp. odo dňa, kedy k vyúčtovaniu došlo. Oneskorené uplatnenie reklamácie
                    môže Prevádzkovateľ zohľadniť pri posudzovaní jej dôvodnosti, najmä ak sťaží preukázanie
                    skutkového stavu.
                </li>
                <li>11.3. Prevádzkovateľ je povinný vystaviť Klientovi potvrdenie o prijatí reklamácie a to buď písomne
                    na adresu Klienta uvedenú v Reklamácii, alebo elektronicky na Klientom uvedený e-mail.
                </li>
                <li>11.4. Reklamácia bude vybavená ihneď, v odôvodnených prípadoch najneskôr do 3 pracovných dní. Ak z
                    dôvodu technickej alebo inej zložitosti nie je možné reklamáciu vybaviť v tejto lehote,
                    Prevádzkovateľ je povinný Klienta informovať o predpokladanej lehote vybavenia, ktorá nesmie
                    presiahnuť 30 dní odo dňa uplatnenia reklamácie.
                </li>
                <li>11.5. V prípade zamietnutia reklamácie je Prevádzkovateľ povinný oznámiť Klientovi dôvody, pre ktoré
                    zodpovednosť za vady Služby neuznáva.
                </li>
                <li>11.6. Reklamáciu je možné uplatniť len na Službu, ktorá bola objednaná a zároveň uhradená u
                    Prevádzkovateľa.
                </li>
                <li>11.7. Klient je oprávnený reklamovať:
                    <ul>
                        <li>(a) kvalitu poskytovanej Služby; a</li>
                        <li>(b) správnosť vyúčtovania ceny za Službu, ak má dôvodnú pochybnosť, že fakturácia
                            nezodpovedá dohodnutým podmienkam alebo platnému cenníku Prevádzkovateľa.
                        </li>
                    </ul>
                </li>
                <li>11.8. Reklamáciu môže Klient uplatniť jedným z nasledujúcich spôsobov:
                    <ul>
                        <li>(a) písomne na adrese sídla Prevádzkovateľa: Rovenská 668/2, 905 01 Senica;</li>
                        <li>(b) elektronicky e-mailom na adrese: info@formafitness.sk.</li>
                    </ul>
                </li>
                <li>11.9. Pri uplatnení reklamácie je Klient povinný uviesť aspoň tieto údaje:
                    <ul>
                        <li>
                            (a) svoje identifikačné a kontaktné údaje (meno, priezvisko/názov, adresa bydliska alebo
                            sídla, telefónne číslo, e-mailová adresa),
                        </li>
                        <li>(b) jasné označenie a popis reklamovanej vady vrátane spôsobu jej prejavu a časového
                            vymedzenia, kedy k vade podľa Klienta došlo; odporúča sa priložiť aj fotodokumentáciu, ak je
                            to možné,
                        </li>
                        <li>(c) vyjadrenie, ktorý z nárokov zo zodpovednosti za vady si Klient uplatňuje (napr. náhradná
                            služba, zľava, vrátenie ceny, atď.),
                        </li>
                        <li>(d) v prípade reklamácie nesprávneho vyúčtovania je nutné uviesť aj dátum platby, ktorej sa
                            reklamácia týka.
                        </li>
                    </ul>
                </li>
                <li>11.10. Prevádzkovateľ nezodpovedá za neúplné alebo nesprávne údaje uvedené Klientom v reklamácii,
                    pokiaľ ich nie je možné doplniť alebo opraviť a Klient nebol schopný tieto údaje poskytnúť ani na
                    základe výzvy Prevádzkovateľa.
                </li>
                <li>11.11. Za deň začatia reklamačného konania sa považuje deň, keď bola riadne vyplnená reklamácia
                    doručená Prevádzkovateľovi. V prípade, že reklamácia neobsahuje všetky požadované údaje podľa bodu
                    11.9. , reklamačné konanie sa začne až dňom doručenia všetkých potrebných náležitostí. Ak Klient
                    tieto údaje na výzvu Prevádzkovateľa nedoplní, reklamácia sa považuje za neodôvodnenú.
                </li>
                <li>11.12. Klient – spotrebiteľ má právo obrátiť sa na Prevádzkovateľa so žiadosťou o nápravu, ak nie
                    je spokojný so spôsobom, ktorým Prevádzkovateľ vybavil jeho reklamáciu, alebo ak sa domnieva, že
                    Prevádzkovateľ porušil jeho práva. Ak Prevádzkovateľ na takúto žiadosť odpovie zamietavo alebo na
                    ňu neodpovie do 30 dní odo dňa jej odoslania, Klient má právo podať návrh na začatie
                    alternatívneho riešenia sporu subjektu alternatívneho riešenia sporov podľa zákona č. 391/2015 Z.
                    z. o alternatívnom riešení spotrebiteľských sporov, ktorým je najmä Slovenská obchodná inšpekcia,
                    Bajkalská 21/A, P. O. BOX 5, 820 07 Bratislava, www.soi.sk. Návrh je možné podať aj elektronicky.
                    Alternatívne riešenie sporu sa netýka sporov, kde hodnota sporu neprevyšuje 20 EUR.
                </li>
            </ul>
        </p>
        <p className={'my-3'}>
            <h4>12. OCHRANA OSOBNÝCH ÚDAJOV</h4>
            <ul>
                <li>12.1. Prevádzkovateľ spracúva osobné údaje fyzických osôb – Klientov v súvislosti s poskytovaním
                    služieb, pričom zabezpečuje ich ochranu podľa GDPR a príslušného zákona.
                </li>
                <li>12.2. Podrobné informácie o spracúvaní osobných údajov, vrátane rozsahu, účelu, právnom základe,
                    doby uchovávania, ako aj o právach dotknutých osôb a spôsobe ich uplatnenia, sú zverejnené v
                    Zásadách ochrany osobných údajov, ktoré sú dostupné v Priestore a na prihlasovacej stránke
                    https://online.iclub.sk/#/ucet/prihlasenie. Osobitné podmienky spracúvania osobných údajov v
                    súvislosti s InBody meraním sú upravené v dokumente „Súhlas so spracúvaním osobných údajov
                    osobitnej kategórie – InBody“ podľa bodu 4.8.2.
                </li>
            </ul>
        </p>
        <p className={'my-3'}>
            <h4>13. ZÁVEREČNÉ USTANOVENIA</h4>
            <ul>
                <li>13.1. Tieto Všeobecné obchodné podmienky nadobúdajú platnosť a účinnosť dňom ich zverejnenia na
                    prihlasovacej stránke https://online.iclub.sk/#/ucet/prihlasenie (športovisko - FORMA Senica).
                </li>
                <li>13.2. Prevádzkovateľ si vyhradzuje právo kedykoľvek jednostranne meniť alebo dopĺňať tieto VOP,
                    pričom zmena nadobúda účinnosť dňom jej zverejnenia na prihlasovacej stránke. Na právne vzťahy
                    vzniknuté pred zverejnením zmeny sa vzťahuje znenie VOP platné a účinné v čase uzavretia zmluvy.
                </li>
                <li>13.3. Právne vzťahy medzi Prevádzkovateľom a Klientom, ktoré nie sú výslovne upravené týmito VOP, sa
                    riadia príslušnými ustanoveniami právneho poriadku Slovenskej republiky, najmä zákonom č. 40/1964
                    Zb. Občiansky zákonník a zákonom č. 108/2024 Z. z. o ochrane spotrebiteľa.
                </li>
                <li>13.4. Ak sa niektoré ustanovenie týchto VOP stane neplatným alebo neúčinným, nedotýka sa to
                    platnosti a účinnosti ostatných ustanovení. Namiesto neplatného alebo neúčinného ustanovenia sa
                    použije ustanovenie, ktoré svojím obsahom a účelom najviac zodpovedá pôvodnému zámeru.
                </li>
                <li>13.5. Klient prihlásením do svojho Konta v Rezervačnom systéme vyhlasuje, že sa oboznámil s týmito
                    VOP, porozumel ich obsahu a v celom rozsahu s nimi súhlasí.
                </li>
            </ul>
        </p>
    </>
}

export default GeneralTermsAndConditions;
